import { render, staticRenderFns } from "./skuCoverSetting.vue?vue&type=template&id=bd886f6e&scoped=true"
import script from "./skuCoverSetting.vue?vue&type=script&lang=js"
export * from "./skuCoverSetting.vue?vue&type=script&lang=js"
import style0 from "./skuCoverSetting.vue?vue&type=style&index=0&id=bd886f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd886f6e",
  null
  
)

export default component.exports